var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chartRef",staticClass:"base-chart"})
}
var staticRenderFns = []

export { render, staticRenderFns }